<template>
  <a-modal wrapClassName="responsive-modal" title="编辑文档" visible @cancel="cancel">
    <ak-inputs v-model="data" :options="options" ref="input" />
    <template slot="footer">
      <a-button @click="cancel">取消</a-button>
      <a-button type="primary" :loading="loading" @click="handleOk">确定</a-button>
    </template>
  </a-modal>
</template>

<script>
export default {
  props: {
    vm: Object,
    record: Object
  },
  data () {
    return {
      loading: false,
      data: {
        theme: '', // 标题
        abstract: '', // 摘要
        content: '' // 正文
      },
      oriTheme: '', // 原始标题
      oriAbstract: '', // 原始摘要
      options: [
        {
          name: 'theme',
          note: '标题:',
          type: 'String'
        },
        {
          name: 'abstract',
          note: '摘要:',
          type: 'String',
        },
        {
          name: 'content',
          note: '正文:',
          type: 'Html'
        }
      ]
    }
  },
  mounted () {
    this.getValue()
    console.log(this.record)
  },
  methods: {
    getValue () {
      this.data.theme = this.record && this.record.theme ? this.record.theme : ''
      this.data.abstract = this.record && this.record.abstract ? this.record.abstract : ''
      this.data.content = this.record && this.record.content ? this.record.content : ''
      this.oriTheme = this.data.theme
      this.oriAbstract = this.data.abstract
    },
    async handleOk () {
      this.loading = true
      let error = await this.$refs.input.validate()
      if (Object.keys(error).length) {
        this.loading = false
        this.$notification['error']({
          message: '操作失败',
          description: '修改信息异常'
        })
      } else {
        this.submit()
      }
      // this.$emit('complete')
    },
    async submit () {
      this.$tkParse.put(`/classes/Docs/${this.record.objectId}`, this.data).catch(e => {
        throw this.$notification['error']({
          message: '网络错误',
          description: '网络错误,请重试'
        })
      })
      if (this.oriTheme !== this.data.theme || this.oriAbstract !== this.data.abstract) { // 修改了摘要或标题，更新图片
        let { data: res } = await this.$tkParse.post('/download', { objectId: this.record.objectId })
        if (res) {
          await this.$tkParse.put(`/classes/Docs/${this.record.objectId}`, { image: res.url }).catch(e => {
            throw this.$notification['error']({
              message: '生成图片失败',
              description: '网络错误,请重试'
            })
          })
        }
      }
      this.$notification['success']({
        message: '操作成功',
        description: '操作完成'
      })
      this.$emit('complete')
      this.vm.refresh()
    },
    cancel () {
      this.$emit('complete')
    }
  }
}
</script>

<style>

</style>
